module.exports = __webpack_public_path__ + "img/farming_46.a5e7d498.png";